










































import { Component, Prop, Ref, Mixins } from "vue-property-decorator";
import { IBlueprint } from "@/models/provisioning";
import HasValidation from "@/mixins/HasValidation";
import BrandFieldsProvider from "@/components/app/admin/settings/provisioning/brandFieldsProvider.vue";
import ManageBrandFieldsForm from "@/components/app/admin/settings/provisioning/manageBrandFieldsForm.vue";

@Component({
  components: {
    "brand-fields-provider": BrandFieldsProvider,
    "manage-brand-fields-form": ManageBrandFieldsForm
  }
})
export default class DomainNameSettings extends Mixins(HasValidation) {
  // Refs
  @Ref("provider") public provider!: BrandFieldsProvider;
  @Ref("manageForm") public manageForm!: ManageBrandFieldsForm;

  @Prop({ required: true })
  public blueprintId!: IBlueprint["id"];

  public form: any = {};
  public initialForm: any = {};

  public get isDisabled() {
    return (
      this.hasErrors ||
      this.$_.isEqual(this.form, this.initialForm) ||
      this.provider?.hasRequestError
    );
  }

  public revertToInitialState() {
    this.manageForm.revertToInitialState();
  }

  public validateBeforeSubmit() {
    try {
      this.provider.providerMethods.setIsProcessing(true);
      this.manageForm.validateBeforeSubmit();
    } finally {
      this.provider.providerMethods.setIsProcessing(false);
    }
  }
}
